
import {
  BaseApplicantSchema
} from '@applyonline/shared'
import * as yup from '@if/core/yup'

export const ApplicantSchema = () => {
  const base = BaseApplicantSchema()
  return base.shape({
    isCoapplicant: yup.boolean().default(false),
    
    relationWithApplicant: yup.string().when('isCoapplicant', (isCoapplicant, schema: yup.StringSchema) => {
      if (!isCoapplicant[0]) {
        return schema.notRequired().nullable().default(null)
      }
      return schema.required().default(null)
    }),
  })
}

export type Applicant = yup.InferSubmit<ReturnType<typeof ApplicantSchema>>
